module.exports = __webpack_public_path__ + "static/img/n18.187fa79.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/resourceShow/img/zh/n18.png
// module id = i/rd
// module chunks = 3